var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTaxonomy = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M9 7.688a2.437 2.437 0 1 0 0-4.875 2.437 2.437 0 0 0 0 4.874Zm-5.437 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5.437 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm5.438 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM9 7.688v4.5M7.68 7.297l-3.304 5.13m5.944-5.13 3.304 5.13" }) }))); };
export default SvgTaxonomy;
